module.exports = __webpack_public_path__ + "img/back8.6cee5d86.png";